var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,on:{"click":function($event){$event.stopPropagation();_vm.handleClick($event)}}},[_c('div',{class:['checkbox-box', 'primary-text', { 'checked': _vm.checked }]},[_c('i',{staticClass:"d-ib material-icons"},[_vm._v("check")])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44c8f53a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkbox.vue
// module id = null
// module chunks = 